var _defs, _rect, _polyline, _circle, _circle2, _line;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDevices = function SvgDevices(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    stroke: "#FFFFFF",
    opacity: 0.8,
    strokeLinejoin: "round",
    strokeWidth: "5.37px",
    strokeLinecap: "round",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a,.b{fill:none;}\n\t\t\t.c{fill:#fff;}\n\t\t\t"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 52.74,
    y: 15.1,
    width: 40.27,
    height: 69.81
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "37.97 66.24 6.99 66.24 6.99 15.1 37.97 15.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 72.87,
    cy: 58.12,
    r: 8.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 72.87,
    cy: 31.27,
    r: 2.28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 22.84,
    y1: 83.72,
    x2: 37.11,
    y2: 83.72
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devices.86268c34.svg";
export { ForwardRef as ReactComponent };